import React, { useState } from 'react';
import Heading from '../../component/Heading/Heading';
import { data } from '../../../config/data';
import { Row, Col, Modal } from 'antd';
import ButtonBackground from '../../component/Buttons/ButtonBackground/ButtonBackground';
import PopupDynamic from '../../component/popup/PopupDynamic';

const LocationSection = ({ setIsThankYouPage, dialCode }) => {
  const [mapModalVisible, setMapModalVisible] = useState(false);
  const [imageModalVisible, setImageModalVisible] = useState(false);


  const openMapModal = () => {
    setMapModalVisible(true);
  };

  const openImageModal = (imageSrc) => {
    setImageModalVisible(true);
  };

  const closeMapModal = () => {
    setMapModalVisible(false);
  };

  const closeImageModal = () => {
    setImageModalVisible(false);
  };

  return (
    <div className='container'>
      <Heading heading={data?.location?.heading} />
      <div style={{ margin: 'auto' }}>
        <Row gutter={[16, 16]}>
          <Col xs={24} md={12}
            style={{
              display: 'flex',
              justifyContent: 'center',
              flexDirection: 'column',
              width: "100%",
              height: "300px",
           
            }}
          >
            <iframe
              src={data?.location?.mapView?.mapLink}
              style={{ width: '100%', margin: 'auto', height: '250px' }}
              allowFullScreen
              loading="lazy"
            ></iframe>
            <div
            
              onClick={openMapModal}>
           
            <ButtonBackground
              text={data?.location?.locationMap?.button}
            
              />
            </div>
          </Col>
          <Col
            style={{
              display: 'flex',
              justifyContent: 'center',
              flexDirection: 'column',
              width:"100%",
              height: "300px",
          
            }}
            xs={24}
            md={12}
          >
            <img
              style={{ width: '100%', margin: 'auto', height: '250px', cursor: 'pointer' }}
              src={data?.location?.locationMap?.imageLink}
              onClick={() => openImageModal(data?.location?.locationMap?.imageLink)

              }
            />
            <div
              onClick={() => openImageModal(data?.location?.locationMap?.imageLink)}
            
            >
              <ButtonBackground
                text={data?.location?.locationMap?.button}
              
              />
            </div>
          </Col>
        </Row>
      </div>

      {/* Map Modal */}
      <Modal
        visible={mapModalVisible}
        onCancel={closeMapModal}
        footer={null}
        centered
      >
        <PopupDynamic
          data={data}
          heading={data?.location?.mapView?.popupData?.heading}
          button={data?.location?.mapView?.popupData?.button}

          dialCode={dialCode}
          setIsThankYouPage={setIsThankYouPage}
        />
      </Modal>

      <Modal
        visible={imageModalVisible}
        onCancel={closeImageModal}
        footer={null}
        centered
      >
        <PopupDynamic
          data={data}
          heading={data?.location?.locationMap?.popupData?.heading}
          button={data?.location?.locationMap?.popupData?.button}
          setIsThankYouPage={setIsThankYouPage}
          dialCode={dialCode}
        />
      </Modal>
    </div>
  );
};

export default LocationSection;
